import React from 'react';
import { Stack } from 'office-ui-fabric-react';
import { TodoFooter } from './TodoFooter';
import { TodoHeader } from './TodoHeader';
import { TodoList } from './TodoList';
export var TodoApp = function () {
    return (React.createElement(Stack, { horizontalAlign: "center" },
        React.createElement(Stack, { style: { width: 400 }, gap: 25 },
            React.createElement(TodoHeader, null),
            React.createElement(TodoList, null),
            React.createElement(TodoFooter, null))));
};
